module.exports = __webpack_public_path__ + "static/media/crashed-rocket2.f2620bdb.jpg";